// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2ZkAm","savePackageButton":"ClientWallet_savePackageButton__aycvq"};